/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exitadminview2Inputs */

const en_exitadminview2 = /** @type {(inputs: Exitadminview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const de_exitadminview2 = /** @type {(inputs: Exitadminview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {Exitadminview2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const exitadminview2 = /** @type {((inputs?: Exitadminview2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exitadminview2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exitadminview2(inputs)
	return de_exitadminview2(inputs)
});
export { exitadminview2 as "exitAdminView" }